/**
 * Raygun.io provider for client-side JavaScript.
 *
 * @see
 * https://github.com/MindscapeHQ/raygun4js
 * https://raygun.com/docs/languages/javascript
 */

import settings from './settings';
import root from './root';

const API_KEY = 'TWNxTXpvUXIvSVU0YWpTaTRqZDV0UT09';

/**
 * @private
 * Injects the script asynchronously.
 *
 * @param {String} url: the URL from where the script will be loaded
 */
function inject(url) {
  /* eslint-disable */
  !function(win,doc,tag,uri,rg4js,script,t,cb){win.RaygunObject=rg4js,win[rg4js]=win[rg4js]||function(){
    (win[rg4js].o=win[rg4js].o||[]).push(arguments)},script=doc.createElement(tag),t=doc.getElementsByTagName(tag)[0],
    script.async=1,script.src=uri,t.parentNode.insertBefore(script,t),cb=win.onerror,win.onerror=function(b,c,d,f,g){
    cb&&cb(b,c,d,f,g),g||(g=new Error(b)),win[rg4js].q=win[rg4js].q||[],win[rg4js].q.push({
    e:g})}}(window,document,"script",url,"rg4js");
  /* eslint-enable */
}

/**
 * @public
 * Initializes Raygun with the default API key.
 *
 * @param {Function} callback: function to configure Raygun. Signature: `callback(rg4js)`
 */
export default function init(callback) {
  inject(`https://assets${settings.isProd ? '' : '.stg'}.healthcare.com/raygun.vanilla.min.js`);
  root.setTimeout(() => {
    rg4js('apiKey', atob(API_KEY));
    rg4js('enableCrashReporting', true);
    rg4js('setVersion', settings.isProd ? settings.version : `${settings.version}-stg`);
    rg4js('whitelistCrossOriginDomains', [
      'healthcare.com',
      'healthcare.org',
      'medicareguide.com',
      'healthcareinsider.com',
      'pivotmedicare.com',
      'pivothealth.com',
    ]);
    rg4js('options', {
      ignoreAjaxAbort: true,
      ignoreAjaxError: true,
      ignore3rdPartyErrors: true,
      allowInsecureSubmissions: false,
      excludedUserAgents: ['Ghost', 'Ghost Inspector', 'PhantomJS'],
      excludedHostnames: [
        /localhost/i,
        /\.?local\./i,
        /\.dev/i,
      ],
    });
    if (typeof callback === 'function') callback(rg4js);
  }, 0);
}
